<template>
    <div id="app">
        <v-app>
            <router-view></router-view>
        </v-app>
    </div>
</template>
<script>
export default {
    data() {
        return {
            user: null,
        };
    },
};
</script>

<style lang="sass" scoped>
#app
    font-family: 'Relative', 'sans-serif'

::v-deep
    a
        text-decoration: none
        color: $color-text
</style>
